<template>
  <div class="solution">
    <AppBar />
    <div class="page-content">
      <div class="solution-canvas">
        <div class="solution-canvas-background">
          <img :src="top.imgBack" alt="" />
        </div>
        <div class="por-container">
          <div class="solution-info">
            <div class="solution-info-title">{{ top.title }}</div>
            <div class="solution-info-content" v-html="top.content">
              <!-- 利用在线招聘流程，帮助企业实现智能、便捷的招聘模式，
              建立企业自己的人才储备机制 -->
            </div>
          </div>
        </div>
      </div>
      <div ref="nav" class="page-nav">
        <div
          ref="navTabs"
          class="page-tabs"
          :style="{ width: navWidth + '%', height: navHeight + 'px' }"
        >
          <div
            v-for="(item, index) in navList"
            :key="index"
            :class="[
              'page-nav-item',
              topNaviId === item.id ? 'top-nav-item' : '',
            ]"
            @click="goAnchor(item)"
          >
            {{ item.title }}
          </div>
        </div>
      </div>
      <div>
        <div ref="pain-points" class="pain-spot">
          <div class="title">企业招聘管理的痛点</div>
          <div v-if="painSpotList.length != 0" class="pain-spot-content">
            <div
              v-for="(item, index) in painSpotList"
              :key="index"
              class="pain-spot-list-item"
            >
              <div class="pain-spot-list-item-card">
                <div class="list-item-icon-wrap">
                  <img :src="item.icon" alt="" class="list-item-icon" />
                </div>
                <div class="list-item-text">
                  <div class="list-item-title">
                    {{ item.title }}
                  </div>
                  <div class="list-item-des">
                    {{ item.describe }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div ref="sense-of-worth" class="product-value-analysis">
          <div class="title">产品价值分析</div>
          <div class="product-value-content">
            <div class="product-value-content-left">
              <div v-if="valueAnalysisList[0]" class="analysis-content">
                <img
                  :src="valueAnalysisList[0].icon"
                  alt=""
                  class="analysis-img"
                />
                <div class="analysis-text">
                  <div class="analysis-num">{{ valueAnalysisList[0].title }}</div>
                  <div class="analysis-content-text">
                    <div
                      v-for="(item, index) in valueAnalysisList[0].textList"
                      :key="index"
                      class="text"
                    >{{ item }}</div>
                  </div>
                </div>
              </div>
              <div v-if="valueAnalysisList[2]" class="analysis-content">
                <img
                  :src="valueAnalysisList[2].icon"
                  alt=""
                  class="analysis-img"
                />
                <div class="analysis-text">
                  <div class="analysis-num">{{ valueAnalysisList[2].title }}</div>
                  <div class="analysis-content-text">
                    <div
                      v-for="(item, index) in valueAnalysisList[2].textList"
                      :key="index"
                      class="text"
                    >{{ item }}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="product-value-content-center">
              <img :src="valueCenterImg" alt="" />
            </div>
            <div class="product-value-content-right">
              <div v-if="valueAnalysisList[1]" class="analysis-content">
                <img
                  :src="valueAnalysisList[1].icon"
                  alt=""
                  class="analysis-img"
                />
                <div class="analysis-text">
                  <div class="analysis-num">{{ valueAnalysisList[1].title }}</div>
                  <div class="analysis-content-text">
                    <div
                      v-for="(item, index) in valueAnalysisList[1].textList"
                      :key="index"
                      class="text"
                    >{{ item }}</div>
                  </div>
                </div>
              </div>
              <div v-if="valueAnalysisList[3]" class="analysis-content">
                <img
                  :src="valueAnalysisList[3].icon"
                  alt=""
                  class="analysis-img"
                />
                <div class="analysis-text">
                  <div class="analysis-num">{{ valueAnalysisList[3].title }}</div>
                  <div class="analysis-content-text">
                    <div
                      v-for="(item, index) in valueAnalysisList[3].textList"
                      :key="index"
                      class="text"
                    >{{ item }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div ref="solution" class="business-solutions">
          <div class="title">招聘系统业务解决方案</div>
          <transition name="solutions-fade" mode="out-in">
            <div v-if="solutionList.length != 0" :key="solutionIndex" class="business-solutions-content">
              <div class="business-solutions-content-left">
                <div class="content-left-text">
                  <div class="text-title">{{ solutionList[solutionIndex].title }}</div>
                  <div class="text-list">
                    <div
                      v-for="(textItem, textIndex) in solutionList[solutionIndex].contentList"
                      :key="textIndex"
                      class="text-list-item"
                    >
                      <img
                        :src="require('@/assets/staffmanage/icon/liIcon.png')"
                        alt=""
                      />
                      <div class="text">{{ textItem }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="business-solutions-content-right">
                <img :src="solutionList[solutionIndex].img" alt="" />
              </div>
            </div>
          </transition>
          <div class="tabinfo-list-wrap">
            <div
              v-for="(item, index) in solutionList"
              :key="index"
              class="tabinfoItem"
              :class="{'chack-tabInfo': index === solutionIndex}"
              @mouseenter="onMouseenter(index)"
            ></div>
          </div>
        </div>
      </div>
      <!-- <div>
        <div ref="data-download" class="data-download">
          <div class="title">行业资料</div>
          <div class="data-download-content">
            <div
              v-for="(item, index) in dataDownloadList"
              :key="index"
              class="data-download-content-item"
            >
              <div class="dataListTitle">{{ item.title }}</div>
              <ul class="data-list">
                <li
                  v-for="(dataItem, dataIndex) in item.dataList"
                  :key="dataIndex"
                  class="data-list-item"
                >
                  <div class="data-list-left">
                    <div class="disc"></div>
                    <div class="data-title">
                      {{ dataItem.title }}
                    </div>
                  </div>
                  <div class="data-list-right">
                    <img
                      :src="require('@/assets/icon/right-arrow.png')"
                      alt=""
                    />
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div> -->
    </div>
    <RightFixedgt />
    <FootWrap />
    <AltProduct ref="altProduct" />
    <ast ref="ast" />
  </div>
</template>

<script>
import { getColumnChild, getColumnDetail } from '@/api/column';
import { getContentList, getContentDetail } from '@/api/content';

export default {
  name: 'ExternalRecruitment',
  data() {
    return {
      top: {
        title: '',
        content: '',
        imgBack: require('@/assets/external/canvas.gif'),
      },
      navWidth: 80,
      navHeight: 60,
      offsetTop: 0,
      scrollTop: 0,
      position: 0,
      topNaviId: null,
      navList: [
        {
          title: '企业痛点',
          id: 'pain-points',
        },
        {
          title: '产品价值观',
          id: 'sense-of-worth',
        },
        {
          title: '解决方案',
          id: 'solution',
        },
      ],
      painSpotList: [
        // {
        //   icon: require('@/assets/solution/icon/pain-spot1.png'),
        //   title: '流程繁琐',
        //   describe: '各个部门招聘流程复杂，线下操作管理成本高',
        // },
        // {
        //   icon: require('@/assets/solution/icon/pain-spot2.png'),
        //   title: '需求繁多',
        //   describe: '岗位要求不一样，简历筛选难度大',
        // },
        // {
        //   icon: require('@/assets/solution/icon/pain-spot3.png'),
        //   title: '安全顾虑多',
        //   describe: '如何进行无接触面试，并保存面试过程痕迹？',
        // },
        // {
        //   icon: require('@/assets/solution/icon/pain-spot4.png'),
        //   title: '数据保存难',
        //   describe: '历史数据无法有效保存分析，人才储备无法实现',
        // },
      ],
      valueCenterImg: '',
      valueAnalysisList: [
        // {
        //   icon: require('@/assets/solution/icon/analysis-content1.png'),
        //   textList: [
        //     '以企业的业务流程为重点',
        //     '打造个性化的招聘模式',
        //   ],
        // },
        // {
        //   icon: require('@/assets/solution/icon/analysis-content2.png'),
        //   textList: [
        //     '通过智能的手段，',
        //     '减轻招聘团队的工作压力，',
        //     '提升招聘效率',
        //   ],
        // },
        // {
        //   icon: require('@/assets/solution/icon/analysis-content3.png'),
        //   textList: [
        //     '建立人才储备方案，',
        //     '让企业用人再无“后顾之忧”',
        //   ],
        // },
        // {
        //   icon: require('@/assets/solution/icon/analysis-content4.png'),
        //   textList: [
        //     '利用BI分析结果快速锁定优质渠道',
        //     '降低招聘成本',
        //   ],
        // },
      ],
      // dataDownloadList: [
      //   {
      //     title: '资料下载',
      //     dataList: [
      //       {
      //         id: 1,
      //         title: '【公告】我们拥有精湛的实施工程师团队工程师团队',
      //       },
      //       {
      //         id: 2,
      //         title: '【公告】具有定制化知识与丰富经验的维丰富经验的',
      //       },
      //       {
      //         id: 3,
      //         title: '【公告】及时为客户解决在使用过程中的过程中的使',
      //       },
      //     ],
      //   },
      //   {
      //     title: '产品动态',
      //     dataList: [
      //       {
      //         id: 4,
      //         title: '【公告】我们拥有精湛的实施工程师团队工程师团队',
      //       },
      //       {
      //         id: 5,
      //         title: '【公告】具有定制化知识与丰富经验的维丰富经验的',
      //       },
      //       {
      //         id: 6,
      //         title: '【公告】及时为客户解决在使用过程中的过程中的使',
      //       },
      //     ],
      //   },
      //   {
      //     title: '干货推荐',
      //     dataList: [
      //       {
      //         id: 7,
      //         title: '【公告】我们拥有精湛的实施工程师团队工程师团队',
      //       },
      //       {
      //         id: 8,
      //         title: '【公告】具有定制化知识与丰富经验的维丰富经验的',
      //       },
      //       {
      //         id: 9,
      //         title: '【公告】及时为客户解决在使用过程中的过程中的使',
      //       },
      //     ],
      //   },
      // ],
      solutionIndex: 0,
      solutionList: [
        // {
        //   title: '简历最适合企业的人才管理模式1',
        //   img: require('@/assets/solution/business-solutions.png'),
        //   contentList: [
        //     '建立个性化岗位智配规则，快速筛选匹配度高的人才',
        //     '利用系统的人才测评工具，帮助企业做到“人尽其才”',
        //     '建立人才储备机制，实现对关键岗位的人才梯队建设，帮助企业实现“岗位继任者”管理模式。',
        //   ],
        // },
        // {
        //   title: '简历最适合企业的人才管理模式2',
        //   img: require('@/assets/solution/business-solutions.png'),
        //   contentList: [
        //     '建立个性化岗位智配规则，快速筛选匹配度高的人才',
        //     '利用系统的人才测评工具，帮助企业做到“人尽其才”',
        //     '建立人才储备机制，实现对关键岗位的人才梯队建设，帮助企业实现“岗位继任者”管理模式。',
        //   ],
        // },
        // {
        //   title: '简历最适合企业的人才管理模式3',
        //   img: require('@/assets/solution/business-solutions.png'),
        //   contentList: [
        //     '建立个性化岗位智配规则，快速筛选匹配度高的人才',
        //     '利用系统的人才测评工具，帮助企业做到“人尽其才”',
        //     '建立人才储备机制，实现对关键岗位的人才梯队建设，帮助企业实现“岗位继任者”管理模式。',
        //   ],
        // },
      ],
    };
  },
  watch: {
    scrollTop(newValue, oldValue) {
      setTimeout(() => {
        if (newValue === window.scrollY) {
          for (var i = 0; i < this.navList.length; i++) {
            var elementTop = this.$refs[`${this.navList[i].id}`].offsetTop - this.scrollTop - 1;
            if (elementTop <= 70) {
              this.topNaviId = this.navList[i].id;
            }
          }
        }
      }, 20);
    },
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll);
    this.$nextTick(() => {
      const nav = this.$refs.nav;
      this.offsetTop = nav.offsetTop;
    });
    this.getPageColumn();
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      var offsetHeight = this.$refs.navTabs.offsetHeight;
      this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      var headerFixed = this.scrollTop > this.offsetTop - offsetHeight / 2 - 70;
      var scroll = this.scrollTop - this.position;
      this.position = this.scrollTop;
      if (this.scrollTop <= 400) {
        this.navHeight = 52;
        this.navWidth = 80;
        this.$refs.nav.style.position = 'relative';
        this.$refs.nav.style.top = '0px';
        this.topNaviId = null;
      } else if (this.scrollTop >= 400 && !headerFixed) {
        this.navHeight += 0.04 * scroll;
        this.navWidth += 0.12 * scroll;
        this.$refs.navTabs.style.top = -(offsetHeight / 2) + 'px';
        this.$refs.nav.style.position = 'relative';
        this.$refs.nav.style.top = '0px';
        this.topNaviId = null;
      } else if (headerFixed) {
        this.navHeight = 60;
        this.navWidth = 100;
        this.$refs.navTabs.style.top = -(offsetHeight / 2) + 'px';
        this.$refs.nav.style.position = 'fixed';
        this.$refs.nav.style.top = offsetHeight / 2 + 70 + 'px';
      }
    },
    goAnchor(i) {
      // var id = '#' + i.id;
      // document.querySelector(id).scrollIntoView({
      //   behavior: 'smooth',
      //   block: 'start',
      // });
      window.scrollTo({
        top: this.$refs[`${i.id}`].offsetTop - 70,
        left: 0,
        behavior: 'smooth',
      });
    },

    // 获取页面栏目
    async getPageColumn() {
      const params = { parentId: '1607260124412600320', };
      getColumnChild(params).then(async (res) => {
        const { result, } = res;
        for (var i = 0; i < result.length; i++) {
          if (result[i].name === '企业痛点') {
            const data = { columnId: result[i].id, pageNum: 1, pageSize: 99, };
            getContentList(data).then(async (rrs) => {
              const rrsult = rrs.result;
              for (var j = 0; j < rrsult.data.length; j++) {
                const rts = await getContentDetail(rrsult.data[j].id);
                const rtsult = rts.result;
                var painSpotItem = {
                  title: rtsult.title,
                  icon: rtsult.icon,
                  describe: rtsult.description,
                };
                this.painSpotList.push(painSpotItem);
              }
            });
          } else if (result[i].name === '产品价值观') {
            const data = { columnId: result[i].id, pageNum: 1, pageSize: 99, };
            this.valueCenterImg = result[i].icon;
            getContentList(data).then(async (rrs) => {
              const rrsult = rrs.result;
              for (var j = 0; j < rrsult.data.length; j++) {
                var valueAnalysisItem = {
                  title: rrsult.data[j].title,
                  icon: rrsult.data[j].icon,
                  textList: [],
                };
                const rts = await getContentDetail(rrsult.data[j].id);
                const rtsult = rts.result;
                for (var x = 0; x < rtsult.elements.length; x++) {
                  valueAnalysisItem.textList.push(rtsult.elements[x].content);
                }
                this.valueAnalysisList.push(valueAnalysisItem);
              }
            });
          } else if (result[i].name === '解决方案') {
            const data = { columnId: result[i].id, pageNum: 1, pageSize: 99, };
            getContentList(data).then(async (rrs) => {
              const rrsult = rrs.result;
              for (var j = 0; j < rrsult.data.length; j++) {
                var solutionItem = {
                  title: rrsult.data[j].title,
                  img: rrsult.data[j].icon,
                  contentList: [],
                };
                const rts = await getContentDetail(rrsult.data[j].id);
                const rtsult = rts.result;
                for (var x = 0; x < rtsult.elements.length; x++) {
                  solutionItem.contentList.push(rtsult.elements[x].content);
                }
                this.solutionList.push(solutionItem);
              }
            });
          } else if (result[i].name === '顶部图') {
            getColumnDetail(result[i].id).then((rrs) => {
              const rrsult = rrs.result;
              var content = rrsult.elements.find(obj => obj.name === 'content').content;
              var contentdoc = new DOMParser().parseFromString(content, 'text/html');
              this.top.title = rrsult.elements.find(obj => obj.name === 'subtitle').content;
              this.top.content = contentdoc.documentElement.textContent.replace(/&nbsp;/g, ' ');
              // this.top = {
              //   imgBack: rrsult.icon,
              // };
            });
          }
        }
      });
    },

    onMouseenter(i) {
      this.solutionIndex = i;
    },
    openBealter () {
      this.$refs.altProduct.tobealter();
    },
    openBealter2() {
       this.$refs.ast.drawer  = true
    },
  },
};
</script>

<style lang="less" scoped>
.solution {
  background-color: #fff;
  .page-content {
    width: 100%;
    .solution-canvas {
      width: 100%;
      height: fit-content;
      min-width: var(--minwidth);
      position: relative;
      background-size: cover;
      .solution-canvas-background {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        background-position: top;
        background-size: cover;
        background-repeat: no-repeat;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          object-position: center top;
        }
      }
      .por-container {
        width: 70%;
        max-width: 1200px;
        margin: 0 auto;
        position: relative;
        .solution-info {
          width: 480px;
          height: 560px;
          display: flex;
          justify-content: center;
          flex-direction: column;
          box-sizing: border-box;
          .solution-info-title {
            font-size: 46px;
            font-weight: bold;
            line-height: 45px;
            color: #181818;
            margin-bottom: 29px;
          }
          .solution-info-content {
            font-size: 20px;
            line-height: 32px;
            color: #7b7b7b;
            margin-bottom: 44px;
          }
          // .solution-btn {
          //   width: 142px;
          //   height: 48px;
          //   background-color: #1589fd;
          //   color: #fff;
          //   text-align: center;
          //   line-height: 48px;
          //   cursor: pointer;
          //   border-radius: 24px;
          // }
        }
      }
    }
    .page-nav {
      width: 100%;
      display: flex;
      position: relative;
      justify-content: center;
      z-index: 50;
      .page-tabs {
        margin: 0 auto;
        box-shadow: 0px 2px 8px 0px rgba(139, 139, 139, 0.18);
        border-radius: 2px;
        background-color: #fff;
        display: flex;
        position: absolute;
        top: -26px;
        .page-nav-item {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #181818;
          font-size: 14px;
          cursor: pointer;
        }
        .page-nav-item:hover {
          color: #00b0dc;
        }
        .top-nav-item {
          color: #fff;
          background-color: #00b0dc;
        }
        .top-nav-item:hover {
          color: #fff;
        }
      }
    }
    .product-value-analysis {
      width: 70%;
      min-width: 1200px;
      margin: 0 auto;
      padding-top: 90px;
      .title {
        font-family: OPPOSans-M;
        font-size: 23px;
        font-weight: 600;
        color: #181818;
        text-align: center;
        margin-bottom: 60px;
      }
      .product-value-content {
        display: flex;
        justify-content: space-between;
        padding-bottom: 100px;
        .product-value-content-left {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: flex-start;
          .analysis-content {
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;
            .analysis-img {
              width: auto;
              height: 25px;
              margin-top: 8px;
            }
            .analysis-text {
              width: 250px;
              height: 180px;
              display: flex;
              flex-direction: column;
              align-items: flex-start;
              margin-left: 15px;
              .analysis-num {
                font-family: FontquanXinYiGuanHeiTi-Regular;
                font-size: 32px;
                color: #181818;
                margin-bottom: 21px;
              }
              .analysis-content-text {
                font-size: 16px;
                color: #181818;
                .text {
                  font-weight: 600;
                  line-height: 25px;
                }
              }
            }
          }
        }
        .product-value-content-center {
          height: 453px;
          img {
            display: block;
            height: 100%;
            width: auto;
          }
        }
        .product-value-content-right {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: flex-start;
          .analysis-content {
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;
            .analysis-img {
              width: auto;
              height: 25px;
              margin-top: 8px;
            }
            .analysis-text {
              width: 250px;
              height: 180px;
              display: flex;
              flex-direction: column;
              align-items: flex-start;
              margin-left: 15px;
              .analysis-num {
                font-family: FontquanXinYiGuanHeiTi-Regular;
                font-size: 32px;
                color: #181818;
                margin-bottom: 21px;
              }
              .analysis-content-text {
                font-size: 16px;
                color: #181818;
                .text {
                  font-weight: 600;
                  line-height: 25px;
                }
              }
            }
          }
        }
      }
    }
    .pain-spot {
      width: 100%;
      padding-top: 115px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      margin: 0 auto;
      .title {
        font-size: 32px;
        color: #181818;
        line-height: 1;
        margin-bottom: 70px;
        font-weight: bold;
      }
      .pain-spot-content {
        width: 1200px;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        margin: 0 auto;
        .pain-spot-list-item {
          width: calc(50% - 40px);
          height: 140px;
          margin: 15px 20px;
          background-color: #f7f9fc;
          .pain-spot-list-item-card {
            width: 100%;
            color: #181818;
            height: 100%;
            padding: 41px 47px 47px 20px;
            box-sizing: border-box;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            .list-item-icon-wrap {
              .list-item-icon {
                width: 45px;
                height: auto;
                opacity: 1;
                display: block;
              }
            }
            .list-item-text {
              margin-left: 25px;
              display: flex;
              flex-direction: column;
              align-items: flex-start;
              .list-item-title {
                font-size: 18px;
                line-height: 1;
                color: #181818;
              }
              .list-item-des {
                width: 100%;
                flex: 1;
                color: #181818;
                font-size: 16px;
                margin-top: 16px;
              }
            }
          }
        }
      }
    }
    .business-solutions {
      width: 1200px;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding-top: 90px;
      position: relative;
      margin-bottom: 36px;
      .title {
        font-size: 32px;
        color: #181818;
        font-weight: bold;
      }
      .business-solutions-content{
        width: 100%;
        margin-top: 70px;
        display: flex;
        .business-solutions-content-left{
            padding-top: 37px;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: flex-start;
            .content-left-text{
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                justify-content: flex-start;
                .text-title{
                    width: 225px;
                    font-size: 28px;
                    color: #181818;
                    font-weight: bold;
                    margin-bottom: 45px;
                }
                .text-list{
                    .text-list-item{
                        display: flex;
                        justify-content: flex-start;
                        align-items: flex-start;
                        margin-bottom: 30px;
                        img{
                            width: 24px;
                            display: block;
                            margin-top: 2px;
                            margin-right: 8px;
                        }
                        .text{
                            width: 384px;
                            font-size: 16px;
                            color: #181818;
                        }
                    }
                }
            }
        }
        .business-solutions-content-right{
            width: 790px;
            height: 470px;
            img{
                width: 100%;
                height: auto;
                display: block;
            }
        }
      }
      .solutions-fade-enter-active {
        animation: bounce-in 1.3s;
      }
      .solutions-fade-leave-active {
        animation: bounce-in .5s reverse;
      }
      @keyframes bounce-in {
        0% {
          opacity: 0;
        }
        100% {
          opacity: 1;
        }
      }
      .tabinfo-list-wrap{
        position: absolute;
        left: 0;
        bottom: 0;
        display: flex;
        // flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        margin-bottom: 60px;
        .tabinfoItem{
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background-color: #e1e6f0;
          margin-right: 16px;
          cursor: pointer;
        }
        .chack-tabInfo{
          background-color: #00b0dc;
        }
      }
    }
    // .data-download {
    //   width: 70%;
    //   min-width: 1209px;
    //   padding-top: 70px;
    //   margin: 0 auto;
    //   display: flex;
    //   flex-direction: column;
    //   justify-content: center;
    //   align-items: center;
    //   padding-bottom: 100px;
    //   .title {
    //     font-size: 32px;
    //     color: #181818;
    //     font-weight: bold;
    //   }
    //   .data-download-content {
    //     display: flex;
    //     margin: 70px auto 0;
    //     .data-download-content-item {
    //       width: 386px;
    //       height: 250px;
    //       margin-right: 21px;
    //       padding: 31px 32px 0 28px;
    //       background: url("@/assets/staffmanage/download-back.png") center;
    //       background-size: cover;
    //       box-sizing: border-box;
    //       .dataListTitle {
    //         font-size: 18px;
    //         color: #181818;
    //         line-height: 1;
    //         margin-bottom: 14px;
    //       }
    //       .data-list {
    //         width: 100%;
    //         display: flex;
    //         flex-direction: column;
    //         justify-content: flex-start;
    //         .data-list-item {
    //           width: 100%;
    //           display: flex;
    //           justify-content: space-between;
    //           margin-top: 19px;
    //           // padding-left: 24px;
    //           box-sizing: border-box;
    //           list-style: disc;
    //           .data-list-left {
    //             display: flex;
    //             align-items: center;
    //             justify-content: flex-start;
    //             .disc {
    //               width: 4px;
    //               height: 4px;
    //               border-radius: 50%;
    //               background-color: #000;
    //             }
    //             .data-title {
    //               width: 254px;
    //               overflow: hidden;
    //               white-space: nowrap;
    //               text-overflow: ellipsis;
    //               font-size: 14px;
    //               color: #181818;
    //               cursor: pointer;
    //               line-height: 1;
    //               position: relative;
    //               margin-left: 20px;
    //             }
    //           }
    //           .data-list-right {
    //             display: flex;
    //             justify-content: center;
    //             align-items: center;
    //             img {
    //               width: auto;
    //               height: 10px;
    //               display: block;
    //             }
    //             display: none;
    //           }
    //         }
    //         .data-list-item:hover {
    //           .data-list-left {
    //             .disc {
    //               background-color: #2979ff;
    //             }
    //             .data-title {
    //               color: #2979ff;
    //             }
    //           }
    //           .data-list-right {
    //             display: block;
    //           }
    //         }
    //       }
    //     }
    //     .data-download-content-item:last-child {
    //       margin-right: 0;
    //     }
    //   }
    // }
  }
}
</style>
